var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Success icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.0297 15.5297C10.7391 15.825 10.2609 15.825 9.97031 15.5297L6.97031 12.5297C6.675 12.2391 6.675 11.7609 6.97031 11.4703C7.26094 11.175 7.73906 11.175 8.02969 11.4703L10.5 13.9406L15.9703 8.47031C16.2609 8.175 16.7391 8.175 17.0297 8.47031C17.325 8.76094 17.325 9.23906 17.0297 9.52969L11.0297 15.5297ZM24 12C24 18.6281 18.6281 24 12 24C5.37188 24 0 18.6281 0 12C0 5.37188 5.37188 0 12 0C18.6281 0 24 5.37188 24 12ZM12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5Z",
    fill: "#2BAC47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/successIcon.358ea8843109bba3f2e47af7f212de62.svg";
export { ForwardRef as ReactComponent };